var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"header"},[_c('el-page-header',{attrs:{"content":_vm.content},on:{"back":_vm.goBack}})],1),_c('div',{staticClass:"bottom"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }